<template>
  <v-snackbar :color="color" :timeout="timeout" v-model="isVisible" top>
    <span>{{ message }}</span>
    <template #action>
      <v-icon @click="isVisible = false">mdi-close</v-icon>
    </template>
  </v-snackbar>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
    },
    message: {
      type: String,
      default: "Успешно",
    },
    color: {
      type: String,
      default: "success",
    },
    timeout: {
      type: Number,
      default: 3000,
    },
  },
  computed: {
    isVisible: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("update:value", value);
      },
    },
  },
};
</script>
